import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/Services/api.service';
import { JwtService } from 'src/app/shared/Services/jwt.service';
import { StorageService } from 'src/app/shared/Services/storage.service';
import { environment } from 'src/environments/environment';
import { ApiPaths } from 'src/app/supplier/models/api-path';
interface DocDto {
  docType: string;
  docName: string;
  docFile: string;
}
@Injectable({
  providedIn: 'root'
})
export class supplierService {
  coreApiPath = '';
  constructor(
    private httpService: ApiService, private storageService: StorageService) {
    this.coreApiPath = `${environment.coreapipath}`;
  }

  getSupplierInfoLookUp(supplierId: number) {
    const localurl = ApiPaths.Supplier.GetSupplierInfo(supplierId);
    return this.httpService.get(localurl);
  }

  saveSupplierContact = (body: any) => {
    let url = ApiPaths.Supplier.SaveContactsWithoutLogin;
    return this.httpService.post(url, body);
  }

  saveContactWithLogin = (body: any) => {
    let url = ApiPaths.Supplier.SaveContactsWithLogin;
    return this.httpService.post(url, body);
  }

  saveSupplierProfile = (body: any) => {
    let url = ApiPaths.Supplier.SaveCompanyInfo;
    return this.httpService.post(url, body);
  }

  removeSuppContact = (contactId: any) => {
    const isLogin: boolean = this.storageService.isLoggedIn();
    let url = isLogin ? ApiPaths.Supplier.DeleteSuppContact(contactId) : ApiPaths.Supplier.DeleteContact(contactId);
    return this.httpService.post(url);
  }

  LoadAllState = (countryId: number) => {
    const localurl = ApiPaths.Supplier.LoadAllState(countryId);
    return this.httpService.get(localurl, undefined, false);
  }

  supplierDetailview(supplierId: any) {
    const localurl = ApiPaths.Supplier.GetSupplier(supplierId);
    return this.httpService.get(localurl);
  }
  supplierInfoview(supplierId: any) {
    const localurl = ApiPaths.Supplier.GetSupplierInf(supplierId);
    return this.httpService.get(localurl);
  }
  supplierBriefInfo(supplierId: any) {
    const localurl = ApiPaths.Supplier.GetSupplierBriefInfo(supplierId);
    return this.httpService.get(localurl);
  }
  getAllSupplier(data: any) {
    const localurl = ApiPaths.Supplier.Search;
    return this.httpService.post(localurl, data, false);
  }
  getHomeSupplier(data: any) {
    const localurl = ApiPaths.Supplier.GetHomeListBySerach;
    return this.httpService.post(localurl, data, false);
  }
  changeStatusActiveInactive(userid: number, status: boolean) {
    const localurl = ApiPaths.Supplier.ChangeStatus;
    let body = {
      "Id": userid,
      "status": status,
    }
    return this.httpService.post(localurl, body);
  }
  changeJobAllotedSupplierStatus(supplierid: number, jobid: number, status: boolean, flag: string) {
    const localurl = ApiPaths.Supplier.JobAllotmentStatus;
    let body = {
      "JobId": jobid,
      "SupplierId": supplierid,
      "Status": status,
      "Flag": flag
    }
    return this.httpService.post(localurl, body);
  }

  addSupplier(data: any) {
    let url = ApiPaths.Supplier.Save;
    return this.httpService.post(url, data);
  }

  isExistSupplierEmail(emailId: string) {
    let url = ApiPaths.Supplier.CheckSupplierEmail;
    const body = {
      emailId : emailId
    }
    return this.httpService.post(url,body,false);
  }
  getSupplierDetails(supplierId: any) {
    const localurl = ApiPaths.Supplier.SupplierDetail(supplierId);
    return this.httpService.get(localurl, undefined, false);
  }

  ApproveSupplier(userId: number) {
    const localurl = ApiPaths.Supplier.SupplierApprove(userId);
    return this.httpService.post(localurl);
  }

  mapSuppToDiffClient(emailId:string) {
    const localurl = ApiPaths.Supplier.MapSupplierToDiffClient(emailId);
    return this.httpService.post(localurl);
  }

updateUserAddress(body:any, supplierId:number) {
  const localurl = ApiPaths.Supplier.SaveProfileAddress;
  const data ={
    supplierId:supplierId,
    countryId:body.countryId,
    stateId:body.stateId,
    city:body.city,
    Address:body.address,
    zipcode:body.zipCode
  }
  return this.httpService.post(localurl, data);
}

  profileSocialUpdate(body: any, supplierId: number) {
    const localurl = ApiPaths.Supplier.SaveSocialLink;
    const data = {
      id: supplierId,
      facebookUrl: body.facebookUrl,
      linkedinUrl: body.linkdinUrl,
      twitterUrl: body.twitterUrl
    }
    return this.httpService.post(localurl, data);
  }

  addstaffingagency(data: any) {
    let url = ApiPaths.Supplier.Save;
    return this.httpService.post(url, data);
  }

  GetLookUp = (clientId: number) => {
    let url = ApiPaths.Supplier.SupplierGetLookUp(clientId);
    return this.httpService.get(url);
  }

  GetAllotedSuppliers(data: any) {
    const localurl = ApiPaths.Supplier.SearchJobAllotmentSupplier;
    return this.httpService.post(localurl, data);
  }

  JobSupplierAllotment = (body: any) => {
    let url = ApiPaths.Supplier.JobSupplierAllotment;
    return this.httpService.post(url, body);
  }

  getSupplierContact(supplierId: number) {
    const isLogin: boolean = this.storageService.isLoggedIn();
    const localurl = isLogin ? ApiPaths.Supplier.GetSuppContacts(supplierId) : ApiPaths.Supplier.GetContacts(supplierId);
    return this.httpService.get(localurl);
  }
  getJobDetails(jobid: number) {
    const localurl = ApiPaths.Supplier.GetJobDetailsByJobId(jobid);
    return this.httpService.get(localurl, undefined, false);
  }

  UploadImage(ImageModel: any): Observable<any> {
    let url = ApiPaths.Supplier.Upload;
    return this.httpService.post(url, ImageModel);
  }

  GetImage(ImageModel: any): Observable<any> {
    let url = ApiPaths.Supplier.GetImage;
    return this.httpService.post(url, ImageModel);
  }

  GetAllImages(payload: { ImageModel: any }): Observable<any> {
    let url = ApiPaths.Supplier.GetAllImages;
    return this.httpService.post(url, payload);
  }

  UpdateJobAllotementStatus(unAssignSupplierVMs: any) {
    const localurl = ApiPaths.Supplier.UnAssignSupplier;
    return this.httpService.post(localurl, unAssignSupplierVMs);
  }
  GetLookUpData(filters: string[]): Observable<any> {
    const localurl = ApiPaths.Supplier.LookUpData;
    return this.httpService.post(localurl, filters);
  }


  addDoc(docDto: DocDto[], formData: any, supplierId: string): Observable<any> {
    const url = ApiPaths.Supplier.CreateDoc;
    const docList = { Docs: docDto, supplierId: supplierId }; // Fix casing to match backend
    return this.httpService.post(url, docList);
  }
  addDocuments(docDto: DocDto[], formData: any, supplierId: number): Observable<any> {
    const url = ApiPaths.Supplier.CreateDocuments;
    const docList = { Docs: docDto, supplierId: supplierId }; // Fix casing to match backend
    return this.httpService.post(url, docList);
  }
  getSupplierData(supplierId: number) {
    const localurl = ApiPaths.Supplier.GetSupplierData(supplierId);
    return this.httpService.get(localurl);
  }

  getSupplierDocData(supplierId: number) {
    const localurl = ApiPaths.Supplier.GetSupplierDocData(supplierId);
    return this.httpService.get(localurl);
  }
  getSupplierDocDatawithoutAuthentication(supplierId: string) {
    const localurl = ApiPaths.Supplier.GetSupplierDocDataWithoutAuth(supplierId);
    return this.httpService.get(localurl);
  }
  getSupplierEPLinkedData() {
    const localurl = ApiPaths.Supplier.GetSupplierLinkEpData;
    return this.httpService.get(localurl);
  }

  getCategories(isAll : boolean) {
    const localurl = ApiPaths.Supplier.GetCategories(isAll);
    return this.httpService.get(localurl);
  }

  getSecCategories(priCatId: number[]) {
    const catIds = {
      categoryIds: priCatId
    }
    const localurl = ApiPaths.Supplier.GetSecCategories;
    return this.httpService.post(localurl,catIds,false);
  }

  SaveCategories(categories: any) {
    const localurl = ApiPaths.Supplier.SaveCategories;
    return this.httpService.post(localurl, categories);
  }
  getCategoriesList() {
    const localurl = ApiPaths.Supplier.GetCategoriesList;
    return this.httpService.get(localurl);
  }
  GetSupplierUploadData(Id:any): Observable<any> {
    const localurl = ApiPaths.Supplier.GetSuplierDocumentsType(Id);
    return this.httpService.get(localurl);
  }
  addDocListWithoutAuth(docDto: DocDto[], formData: any, supplierId: string): Observable<any> {
    const url = ApiPaths.Supplier.SaveUploadedDocsWithoutAuth;
    const docList = { Docs: docDto, supplierId: supplierId }; // Fix casing to match backend
    return this.httpService.post(url, docList);
  }
  GetSupplierDocumentsData(supplierId: number) {
    const localurl = ApiPaths.Supplier.GetSupplierDocumentsData(supplierId);
    return this.httpService.get(localurl);
  }

  GetSupplierDocumentTypes(supplierId:any): Observable<any> {
    const localurl = ApiPaths.Supplier.GetSuplierDocTypeList(supplierId);
    return this.httpService.get(localurl);
  }
  getSupplierUploadedDocData(supplierId: number) {
    const localurl = ApiPaths.Supplier.getSupplierUploadedDocData(supplierId);
    return this.httpService.get(localurl);
  }
  addUploadedDocuments(docDto: DocDto[], formData: any, supplierId: number): Observable<any> {
    const url = ApiPaths.Supplier.addUploadedDocuments;
    const docList = { Docs: docDto, supplierId: supplierId }; // Fix casing to match backend
    return this.httpService.post(url, docList);
  }
}
